import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function BoxEditForm(
  {
    data = {},
    onChange = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "name-value",
    weeks = [],
  },
  ref
) {
  const handleChange = (v) => {
    onChange({name: "address", value : v?.address ?? {}});
  }
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={handleChange}
        type={type}
        layout={[
          {
            name: "address",
            label: "Delivery Addressdf",
            placeholder: "Your delivery address here",
            type: "address",
            required: true,
            startIcon: "LocationOnOutlined",
            itemSize: { lg: 6, md: 6, sm: 12, xs: 12 },
          }
        ]}
        isLabel
        alignItems="flex-start"
        fullWidth={true}
        direction="row"
        spacing={2}
      />
    </div>
  );
});
